import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { connect } from 'react-redux'

import { ParticipantSubHeader } from 'components/sections/assessor'
import { apiAssessors } from 'helpers/decorators/api'
import { ACTIVITY_SECTIONS } from 'constants/enums'
import { renderRoutes } from 'react-router-config'
import config from 'config'

@apiAssessors()
@connect((state, props) => {
  const { assessor, params } = props

  const activeAward = get(assessor, 'participants.list', []).find(
    participant =>
      get(participant, 'residentialProject.id') === Number(params.rpId)
  )

  return {
    activeProject: get(activeAward, 'residentialProject'),
    activeAward,
    activeParticipant: get(activeAward, 'participant')
  }
})
class RPDetailAssessor extends Component {
  static propTypes = {
    route: PropTypes.object,
    activeProject: PropTypes.object,
    activeAward: PropTypes.object,
    activeParticipant: PropTypes.object,
    params: PropTypes.object
  }

  render() {
    const {
      activeAward,
      activeProject,
      activeParticipant,
      route,
      params
    } = this.props

    return (
      <div>
        <ParticipantSubHeader
          activityRoute={`${config.publicPath}/assessor/residential-project/${params.rpId}`}
          activitySection={ACTIVITY_SECTIONS.residential_project.id}
          avatar={get(activeParticipant, 'photoUrl')}
          completionText={get(activeProject, 'activitySection.translationText')}
          hideProgress
          showReport
          name={get(activeParticipant, 'name')}
        />
        {route && renderRoutes(route.routes, {
          residentialProject: activeProject,
          award: activeAward,
          isAssessor: true,
          isRP: true
        })}
      </div>
    )
  }
}

export default RPDetailAssessor
